(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cpo-product-template-v7"] && !Shopify.designMode) return;
  try {
     // Misc
  // Required checkbox before form submit
  document.getElementById("acceptTermsConditions").required = true;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-owned-rolex-bespoke-product-template"] && !Shopify.designMode) return;
  try {
     // Misc
  // Required checkbox before form submit
  document.getElementById("acceptTermsConditions").required = true;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rolex-bespoke-collection-template-v7"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
var loadMoreButton = document.getElementById('load-more');

if (loadMoreButton) {
loadMoreButton.addEventListener('click', function() {
var hiddenProducts = document.querySelectorAll('.hidden-product');
var productsToShow = Array.prototype.slice.call(hiddenProducts, 0, 6);

productsToShow.forEach(function(product) {
product.classList.remove('hidden-product');
});

if (document.querySelectorAll('.hidden-product').length === 0) {
loadMoreButton.style.display = 'none';
}
});
}
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rolex-bespoke-collection-template"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var loadMoreButton = document.getElementById('load-more');
  
  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', function() {
      var hiddenProducts = document.querySelectorAll('.hidden-product');
      var productsToShow = Array.prototype.slice.call(hiddenProducts, 0, 6);

      productsToShow.forEach(function(product) {
        product.classList.remove('hidden-product');
      });

      if (document.querySelectorAll('.hidden-product').length === 0) {
        loadMoreButton.style.display = 'none';
      }
    });
  }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rolex-bespoke-product-template-v7"] && !Shopify.designMode) return;
  try {
     // Misc
  document.getElementById("acceptTermsConditions").required = true;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rolex-bespoke-product-template"] && !Shopify.designMode) return;
  try {
     // Misc
  // Required checkbox before form submit
  document.getElementById("acceptTermsConditions").required = true;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rolex-certified-preowned-selection-v7"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var loadMoreButton = document.getElementById('load-more');
  
  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', function() {
      var hiddenProducts = document.querySelectorAll('.hidden-product');
      var productsToShow = Array.prototype.slice.call(hiddenProducts, 0, 6);

      productsToShow.forEach(function(product) {
        product.classList.remove('hidden-product');
      });

      if (document.querySelectorAll('.hidden-product').length === 0) {
        loadMoreButton.style.display = 'none';
      }
    });
  }
});

/* FORCE FULL PAGE RELOAD FOR PAGINATION */
document.addEventListener(
  'click',
  function (e) {
    const link = e.target.closest('.gspf-page');
    if (!link || !link.href) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // Force real navigation so Shopify reloads page + products
    window.location.assign(link.href);
  },
  true // 👈 capture phase (THIS is critical)
);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rolex-product-template-v7-2025"] && !Shopify.designMode) return;
  try {
     // Misc
  document.getElementById("acceptTermsConditions").required = true;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rolex-product-template-v7-2026"] && !Shopify.designMode) return;
  try {
     // Misc
  document.getElementById("acceptTermsConditions").required = true;

  } catch(e) { console.error(e); }
})();
})();
